var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "176 86 476 410",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.42,89.36c-57.44,53.74-87.68,125.67-90.12,198.53c-2.43,72.86,22.92,146.65,76.64,204.11l0.3-0.29 v-20.99c-88.19-105.57-82.74-261.7,12.77-360.86l130.08,139.11l9.02-9.02L271.42,89.36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.15,130.99c-37.59,43.96-59.16,99.46-61.12,157.86c-1.9,57.14,15.09,112.76,48.21,158.55v-26.05 c-23.53-39.54-35.47-85.57-33.9-132.01c1.63-49.34,18.45-97.21,47.67-136.48l108.82,116.38l10.13-10.13L271.15,130.99z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.73,175.66c-21.39,34-33.74,73.92-35.09,114.14c-1.15,34.33,5.71,68.97,19.6,100.36v-45.05 c-4.11-17.94-5.91-36.37-5.3-54.82c1.06-31.56,9.16-62.57,23.59-90.68l84.04,89.88l10.12-10.12L273.73,175.66z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M647.24,287.89c-2.45-72.86-32.68-144.79-90.12-198.53L417.3,238.83l10.13,10.13l130.09-139.09 c95.51,99.16,100.96,255.29,12.77,360.86v20.99l0.3,0.29C624.32,434.54,649.67,360.75,647.24,287.89z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M570.3,447.4c33.12-45.79,50.12-101.4,48.21-158.55c-1.96-58.4-23.53-113.9-61.12-157.86L437.57,259.1 l10.13,10.13l108.82-116.38c29.22,39.26,46.04,87.13,47.67,136.48c1.57,46.44-10.36,92.47-33.9,132.01V447.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M570.3,390.17c13.89-31.39,20.74-66.03,19.6-100.36c-1.35-40.22-13.7-80.15-35.09-114.14l-96.98,103.69 l10.12,10.12L552,199.61c14.43,28.11,22.53,59.12,23.59,90.68c0.62,18.45-1.19,36.89-5.3,54.82V390.17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkM);
export default __webpack_public_path__ + "static/media/mark-m.965e5fac9cf74616c1909e27109617cf.svg";
export { ForwardRef as ReactComponent };